import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpStatusCode } from "@angular/common/http";
import { inject } from "@angular/core";
import { environment } from "@environments/environment";
import { Router } from "@services/route.service";
import { ActivatedRoute, Router as NgRouter } from "@angular/router";
import { User } from "@services/user.service";
import { tap } from "rxjs";


export const apiRequestInterceptorOld: HttpInterceptorFn=(req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const userS=inject(User);
  // if it is a Github API request
  if(req.url.includes(environment.servicesUrl) && userS.isConnected()){
    // we need to add an OAUTH token as a header to access the Github API
    const clone=req.clone({ setHeaders: { 'X-Access-Session': userS.getSession() } });
    return next(clone);
  }

  // if it's not a Github API request, we just hand it to the next handler
  return next(req);
};

export const apiRequestInterceptor: HttpInterceptorFn=(req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const userS=inject(User);

  // Ne modifier que les requêtes envoyées à notre API.
  if (!req.url.includes(environment.servicesUrl)) {
    return next(req);
  }

  /*
   * Contourne le service worker Angular.
   *
   * L'utilisation du paramètre d'URL évite d'ajouter
   * un nouveau header CORS personnalisé.
   */
  let apiRequest=req.clone({
    params: req.params.set('ngsw-bypass', 'true')
  });

  if(userS.isConnected()){
    apiRequest=apiRequest.clone({
      setHeaders: {
        'X-Access-Session': userS.getSession()
      }
    });
  }

  return next(apiRequest);
};


export const apiResponseInterceptor: HttpInterceptorFn=(req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const router=inject(Router);
  const ngRouter=inject(NgRouter);
  const route=inject(ActivatedRoute);
  const userS=inject(User);

  return next(req).pipe(
    // we catch the error
    tap({
      error: (errorResponse: HttpErrorResponse) => {
        // if the status is 401 Unauthorized => redirect
        if(errorResponse.status===HttpStatusCode.Unauthorized && !route.snapshot.queryParamMap.get('redirect')){
          userS.unlog()
            .subscribe(() => router.navigate('login', [], {redirect: ngRouter.url}));
        }
        
        // if the status is 404 => redirect
        if(errorResponse.status===HttpStatusCode.NotFound)
          router.navigate('collect-home');
      }
    })
  );
};
